<template>
  <div class="wraper-loginreg login">
    <div class="main">
      <img class="open-img" src="../assets/open.png" alt="open"/>
      <div class="wraper-main">
        <div class="main-inner login-inner">
          <div class="logo-btn-box">
            <img
              class="logo"
              src="@/assets/logo.png"
              alt="logo"
              @click="handleToHome"
            />
            <el-button
              class="custom-button btn-17151c btn-toreg"
              @click="handleToReg"
            >立即注册
            </el-button
            >
          </div>
          <div class="title">登录</div>
          <div class="tab">
            <div
              :class="['tab-item-main', loginType == 1 ? 'active' : '']"
              @click="handleSelLoginType(1)"
            >
              <div class="tab-item tab-item-account">
                <div class="icon-box"></div>
                <div class="item-name">账号登录</div>
              </div>
            </div>
            <div
              :class="['tab-item-main', loginType == 0 ? 'active' : '']"
              @click="handleSelLoginType(0)"
            >
              <div class="tab-item tab-item-phone">
                <div class="icon-box"></div>
                <div class="item-name">短信验证码登录</div>
              </div>
            </div>
          </div>
          <el-form
            class="form-box login-form"
            ref="loginForm"
            :label-position="labelPosition"
            label-width="80px"
            :model="loginFormData"
            :rules="rules"
          >
            <div>
              <div class="form-item">
                <div class="label">手机号</div>
                <el-form-item prop="user_phone">
                  <el-input
                    class="custom-input"
                    v-model="loginFormData.user_phone"
                    placeholder="请输入"
                    maxlength="11"
                    autocomplete="on"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="form-item" v-show="loginType == 0">
                <div class="label">验证码</div>
                <el-form-item prop="pic_code">
                  <el-input
                    class="custom-input verifycode"
                    v-model="loginFormData.pic_code"
                    placeholder="请输入"
                    autocomplete="off"
                  ></el-input>
                  <img
                    class="img-code"
                    :src="imgCodeUrl"
                    @click="refreshImgCode"
                  />
                </el-form-item>
              </div>
              <div class="form-item" v-show="loginType == 0">
                <div class="label">手机验证码</div>
                <el-form-item prop="msg_content">
                  <el-input
                    class="custom-input phonecode"
                    v-model="loginFormData.msg_content"
                    placeholder="请输入"
                    autocomplete="off"
                  ></el-input>
                  <el-button
                    class="
                      custom-button
                      btn-fff3f3
                      inputtext-button
                      btn-phonecode
                    "
                    @click="handleSendPhoneCode"
                  >{{ sendCodeText }}
                  </el-button>
                </el-form-item>
              </div>
              <div class="form-item" v-show="loginType == 1">
                <div class="label">密码</div>
                <el-form-item prop="password_user">
                  <el-input
                    class="custom-input inputtext-password"
                    v-model="loginFormData.password_user"
                    placeholder="请输入"
                    type="password"
                    show-password
                    autocomplete="on"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="form-item" v-show="loginType == 1">
                <div class="label">验证码</div>
                <el-form-item prop="pic_code">
                  <el-input
                    class="custom-input verifycode"
                    v-model="loginFormData.pic_code"
                    placeholder="请输入"
                    autocomplete="off"
                  ></el-input>
                  <img
                    class="img-code"
                    :src="imgCodeUrl"
                    @click="refreshImgCode"
                  />
                </el-form-item>
              </div>
              <div class="form-item auto-forget-item" v-show="loginType == 1">
                <el-checkbox
                  class="custom-checkbox"
                  v-model="loginFormData.isAuto"
                >下次自动登录
                </el-checkbox
                >
                <div class="btn-forget" @click="handleToReset">忘记密码</div>
              </div>
            </div>
            <el-button
              :class="[
                'custom-button',
                'btn-ff3333',
                'btn-operate',
                'btn-login',
                loginType == 1 ? 'btn-login-account' : '',
              ]"
              :disabled="isDisableLogin"
              @click="handleLogin"
            >登录
            </el-button
            >
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import storage from "@/utils/customLocalStorage";
import {phoneValidator, timeLoop} from "@/assets/js/util";
import auth from "@/utils/auth";
import pageCommon from "@/utils/pagecommon";
import imgCodeApi from "@/api/imgcode";
import accountApi from "@/api/account";
import sendpohnecodeMixin from "@/views/mixins/sendphonecode";

export default {
  name: "Login",
  mixins: [sendpohnecodeMixin],
  data() {
    return {
      loginType: 1,
      labelPosition: "top",
      loginFormData: {
        user_phone: "",
        msg_content: "",
        pic_code: "",
        password_user: "",
        isAuto: "",
      },
      messageLoginData: {
        user_phone: "",
        code: "",
        piccode: "",
      },
      accountLoginData: {
        user_phone: "",
        pwd: "",
        piccode: "",
        isAuto: "",
      },
      accountLoginShowPwd: false,
      //发送验证码操作
      sendphoneValideForName: "loginForm",
      sendPhoneFormeDataName: "loginFormData",
      valideFieldPhoneItemName: "user_phone",
      valideFieldPicCode: "pic_code",
      //发送验证码结束------------------------
      imgCodeUrl: "",
      rules: {
        user_phone: [
          {required: true, message: "填写正确的手机号码", trigger: "blur"},
          {validator: phoneValidator, trigger: "blur"},
        ],
        accountNum: [
          {required: true, message: "填写手机号", trigger: "blur"},
        ],
        msg_content: [
          {required: true, message: "填写手机验证码", trigger: "blur"},
        ],
        password_user: [
          {required: true, message: "填写密码", trigger: "blur"},
        ],
        pic_code: [{required: true, message: "填写验证码", trigger: "blur"}],
      },
      // 请求控制
      isRequesting: false,
    };
  },
  computed: {
    isDisableLogin: function () {
      let _this = this;
      if (_this.loginFormData.user_phone && _this.loginFormData.pic_code) {
        if (_this.loginType == 0 && _this.loginFormData.msg_content) {
          return false;
        }
        if (_this.loginType == 1 && _this.loginFormData.password_user) {
          return false;
        }
        return true;
      }
    },
  },
  mounted() {
    let _this = this;
    if (JSON.parse(storage.read('password')) && JSON.parse(storage.read('usershop'))) {
      _this.loginFormData.user_phone = JSON.parse(storage.read('usershop')).public_user_info.user_phone
      _this.loginFormData.password_user = JSON.parse(storage.read('password'))
    }
    _this.refreshImgCode();
  },
  methods: {
    refreshImgCode: function () {
      let _this = this;
      let imgCodeObj = imgCodeApi.getImgCodeUrl();
      _this.imgCodeUrl = imgCodeObj.url;
    },
    handleToHome: function () {
      let _this = this;
      _this.$router.push("/");
    },
    handleSelLoginType: function (type) {
      let _this = this;
      if (_this.loginType == type) {
        return;
      }
      _this.loginType = type;
      // if (_this.timerObj && _this.timerObj.timer) {
      //   clearTimeout(_this.timerObj.timer);
      //   _this.sendCodeText = "发送验证码";
      //   _this.timeCount = 0;
      // }
      // _this.$nextTick(() => {
      //   if (_this.loginType == 0) {
      //     _this.$refs.messageloginForm.clearValidate();
      //   }
      //   if (_this.loginType == 1) {
      //     _this.$refs.accountloginForm.clearValidate();
      //   }
      // });
      _this.refreshImgCode();
    },
    handleToReg: function () {
      let _this = this;
      _this.$router.push("/register");
    },
    handleToReset: function () {
      let _this = this;
      _this.$router.push("/resetpwd");
    },
    
    handleLogin: function () {
      let _this = this;
      if (_this.isRequesting) {
        return;
      }
      _this.isRequesting = true;
      let fields = ["user_phone", "pic_code"];
      if (_this.loginType == 0) {
        fields.push("msg_content");
      }
      if (_this.loginType == 1) {
        fields.push("password_user");
      }
      Promise.all(
        fields.map((item) => {
          return new Promise((resolve, reject) => {
            this.$refs["loginForm"].validateField(item, (result) => {
              resolve(result);
            });
          });
        })
      ).then((result) => {
        let valid = true;
        for (let i = 0; i < result.length; i++) {
          const element = result[i];
          if (element) {
            valid = false;
            break;
          }
        }
        if (valid) {
          if (_this.loginType == 0) {
            _this.messageLogin();
          }
          if (_this.loginType == 1) {
            _this.passwordLogin();
          }
        } else {
          _this.isRequesting = false;
        }
      });
    },
    messageLogin: function () {
      let _this = this;
      let requestData = {
        user_phone: _this.loginFormData.user_phone,
        msg_content: _this.loginFormData.msg_content,
        isloading: true,
      };
      pageCommon
        .apiRequestCommon(accountApi, "phoneCodeLogin", requestData)
        .then(
          (res) => {
            _this.loginSuccessCallback(res);
          },
          (err) => {
            _this.isRequesting = false;
            _this.timeCount = 0
            _this.refreshImgCode()
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
              _this.$message.error(err.data.msg);
            }
          }
        );
    },
    passwordLogin: function () {
      let _this = this;
      let requestData = {
        user_phone: _this.loginFormData.user_phone,
        password_user: _this.loginFormData.password_user,
        pic_code: _this.loginFormData.pic_code,
        isloading: true,
      };
      pageCommon.apiRequestCommon(accountApi, "pwdLogin", requestData).then(
        (res) => {
          let expire = null;
          if (_this.loginFormData.isAuto) {
            expire = 3600 * 24 * 30;
          }
          _this.loginSuccessCallback(res, expire);
        },
        (err) => {
          _this.isRequesting = false;
          _this.refreshImgCode()
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    loginSuccessCallback: function (user, expire) {
      let _this = this;
      
      pageCommon
        .apiRequestCommon(accountApi, "getUserShopInfo", {
          isloading: false,
        })
        .then(
          (res) => {
            _this.isRequesting = false;
            let resUserInfo = user.public_user_info;
            let strToken = JSON.stringify({
              id_public_user_info: resUserInfo.id_public_user_info,
              user_type: resUserInfo.user_type,
              nick_name: resUserInfo.nick_name,
              weichat_img: resUserInfo.weichat_img,
            });
            auth.setToken(strToken, expire);
            _this.$store.dispatch("acToken", strToken);
            _this.$store.dispatch("acUser", user.public_user_info);
            storage.set("user", JSON.stringify(user.public_user_info));
            storage.set("password", JSON.stringify(_this.loginFormData.password_user));
            storage.set("isAuto", JSON.stringify(_this.loginFormData.isAuto));
            _this.$store.dispatch("acUserShopInfo", res);
            storage.set("usershop", JSON.stringify(res));
            _this.$router.push("/");
          },
          (err) => {
            _this.isRequesting = false;
            _this.refreshImgCode()
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
              _this.$message.error(err.data.msg);
            }
          }
        );
    },
    handleShowAccountPwd: function () {
      let _this = this;
      _this.accountLoginShowPwd = !_this.accountLoginShowPwd;
    },
    handleMockLogin: function () {
      let _this = this;
      // TODO:TEST
      console.log("mock,")
      let user = {
        public_user_info: {
          id_public_user_info: 2000,
          weichat_img: "",
          nick_name: "",
          user_phone: "15975424634",
          isVip: false,
          userMoney: 200
        },
      };
      let expire = 3600 * 24 * 30;
      
      //TODO:TEST
      let resUserInfo = user.public_user_info;
      let strToken = JSON.stringify({
        id_public_user_info: resUserInfo.id_public_user_info,
        user_type: resUserInfo.user_type,
        nick_name: resUserInfo.nick_name,
        weichat_img: resUserInfo.weichat_img,
        isVip: resUserInfo.isVip,
        userMoney: resUserInfo.userMoney
      });
      let usershopInfo = "11111111111111111111";
      auth.setToken(strToken, expire);
      _this.$store.dispatch("acToken", strToken);
      _this.$store.dispatch("acUser", user.public_user_info);
      storage.set("user", JSON.stringify(user.public_user_info));
      _this.$store.dispatch("acUserShopInfo", usershopInfo);
      storage.set("usershop", JSON.stringify(usershopInfo));
      _this.$router.push("/");
      
      //TEST END
    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/css/common.less";
@import "../assets/css/loginreg.less";

.login {
  .main-inner {
    &.login-inner {
      width: 370px;
      
      .logo-btn-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 64px;
        
        .logo {
          width: 130px;
          height: 50px;
          cursor: pointer;
        }
        
        .btn-toreg {
          width: 82px;
          height: 32px;
          line-height: 32px;
          font-size: 14px;
        }
      }
      
      .tab-item-main {
        .tab-item-phone {
          .icon-box {
            background: url("../assets/icon_message_unselelct.png") no-repeat center center;
            background-size: 20px 20px;
          }
        }
        
        .tab-item-account {
          .icon-box {
            background: url("../assets/icon_account_unselected.png") no-repeat center center;
            background-size: 20px 20px;
          }
        }
        
        &.active {
          .tab-item-phone {
            .icon-box {
              background: url("../assets/icon_message_selected.png") no-repeat center center;
              background-size: 20px 20px;
            }
          }
          
          .tab-item-account {
            .icon-box {
              background: url("../assets/icon_account_selected.png") no-repeat center center;
              background-size: 20px 20px;
            }
          }
        }
      }
      
      .login-form,
      .messagelogin-form,
      .accountlogin-form {
        .form-item {
          margin-top: 16px;
          
          /deep/ .el-form-item {
            margin-bottom: 0;
            
            &.is-error {
              margin-bottom: 32px;
            }
          }
          
          &:last-child {
            /deep/ .el-form-item {
              margin-bottom: 0px;
              
              &.is-error {
                margin-bottom: 0;
              }
            }
          }
          
          &:first-child {
            margin-top: 30px;
          }
          
          &.auto-forget-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            
            .btn-forget {
              font-size: 14px;
              font-family: "SourceHanSansCN";
              color: rgb(102, 102, 102);
              line-height: 14px;
              cursor: pointer;
            }
          }
          
          .phonecode,
          .verifycode {
            /deep/ .el-input__inner {
              padding-right: 113px;
            }
          }
          
          .btn-phonecode {
            position: absolute;
            right: 5px;
            top: 5px;
            margin-left: 0;
            margin-right: 0;
          }
          
          .img-code {
            position: absolute;
            right: 5px;
            top: 5px;
            margin-left: 0;
            margin-right: 0;
            cursor: pointer;
          }
        }
        
        .btn-operate {
          margin-top: 40px;
          
          &.btn-login-account {
            margin-top: 16px;
          }
        }
      }
    }
  }
}
</style>
